module.exports = __webpack_public_path__ + "static/media/Mikse.d1b876d6.m4a";